module.exports = function () {
    return function (text) {
        return text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/filters/wow-html-to-plain-text.js
 **/